import * as ActionTypes from './actionTypes'

export const fetchStart = () => ({
  type: ActionTypes.FETCH_START,
})
export const fetchSuccess = (incidents) => ({
  type: ActionTypes.FETCH_SUCCESS,
  incidents,
})
export const fetchFail = () => ({
  type: ActionTypes.FETCH_FAILURE,
})

export const fetchPalmettoIncidentsStart = () => ({
  type: ActionTypes.FETCH_PALMETTO_INCIDENTS_START,
})
export const fetchPalmettoIncidentsSuccess = (incidents) => ({
  type: ActionTypes.FETCH_PALMETTO_INCIDENTS_SUCCESS,
  incidents,
})
export const fetchPalmettoIncidentsFail = () => ({
  type: ActionTypes.FETCH_PALMETTO_INCIDENTS_FAILURE,
})

export const fetchEventTypesStart = () => ({
  type: ActionTypes.FETCH_EVENT_TYPES_START,
})
export const fetchEventTypesSuccess = (types) => ({
  type: ActionTypes.FETCH_EVENT_TYPES_SUCCESS,
  types,
})
export const fetchEventTypesFail = () => ({
  type: ActionTypes.FETCH_EVENT_TYPES_FAILURE,
})

export const selectIncidents = (incidentIds) => ({
  type: ActionTypes.SELECT_INCIDENTS,
  incidentIds,
})
export const nextIncident = () => ({ type: ActionTypes.NEXT_INCIDENT })
export const prevIncident = () => ({ type: ActionTypes.PREV_INCIDENT })
export const clearSelection = () => ({ type: ActionTypes.CLEAR_SELECTION })

export const hover = (incidentId) => ({ type: ActionTypes.HOVER, incidentId })
export const endHover = (incidentId) => ({
  type: ActionTypes.END_HOVER,
  incidentId,
})

export const openForm = () => ({ type: ActionTypes.OPEN_FORM })
export const closeForm = () => ({ type: ActionTypes.CLOSE_FORM })
export const setTitle = (title) => ({ type: ActionTypes.SET_TITLE, title })
export const setEventType = (eventType) => ({
  type: ActionTypes.SET_EVENT_TYPE,
  eventType,
})
export const setIncident = (incident) => ({
  type: ActionTypes.SET_INCIDENT,
  incident,
})

export const sendToPalmetto = (incidentNumber) => ({
  type: ActionTypes.SEND_TO_PALMETTO,
  incidentNumber,
})
